import fileSize from "filesize";

import { abbreviateNumber } from "helpers/abbreviate-number";

export const filters = {
    install: (Vue) => {
        Vue.filter("abbreviate", (value) => {
            if (typeof value !== "number") {
                return value;
            }

            return abbreviateNumber(value);
        });

        Vue.filter("filesize", (value) => {
            if (typeof value !== "number") {
                return value;
            }

            return fileSize(value);
        });

        Vue.filter("formatNumber", (value) => {
            if (typeof value !== "number") {
                return value;
            }

            return new Intl.NumberFormat().format(value);
        });

        Vue.filter("formatDate", (value) => {
            if (typeof value === "number" || typeof value === "string") {
                return new Intl.DateTimeFormat().format(new Date(value));
            }

            if (typeof value === "object" && typeof value.getMonth === "function") {
                return new Intl.DateTimeFormat().format(value);
            }

            return value;
        });
    }
};

export default filters;
